// extracted by mini-css-extract-plugin
export var cardHeader = "_t6-0";
export var reorderHandle = "_t6-3";
export var titleArea = "_t6-1";
export var titleAreaWithHandle = "_t6-2";